export default "__VITE_ASSET__fBoiXYhJ__"